module.exports = __webpack_public_path__ + "img/banner03_info_news.23e8af00.svg";